import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { TopicsProvider as Provider } from '@shapeable/ui';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const TOPICS_QUERY = graphql`
query NodeAllTopicsQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Topics" } }) {
    nodes {
      data
    }
  }
}
`;

export const TopicsProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(TOPICS_QUERY), 'items')}>{children}</Provider>;
};
